import { useCallback, useEffect, useReducer, useRef, useState } from "react";
import hbricon from "../otherImg/hbrlitenewicon.png";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";
import { getDownloadURL, ref as storageRef, uploadBytesResumable } from "firebase/storage";
import db, { storage } from "../firebase";
import { Timestamp,collection,doc,getDoc,getDocs,limit, onSnapshot, orderBy, query, startAfter, where} from "firebase/firestore";
import { format } from "date-fns";
import { Button, CircularProgress } from "@mui/material";
import BlogContent from "../BlogContent";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { getMySavedPosts, initDB } from "../ConfigureIndexDB";
import DivineShorts from "./DivineShorts";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import {HbrAddIcon, HbrArrowLeft, HbrAvatarProfile, HbrAvatarProfile2, Hbrbackarrow, HbrBoldIcon, HbrCloseIcon, HbrEditIcon, HbrExitIcon, HbrHighlightIcon, HbrIconFileCopy, HbrImageIcon, HbrItalicIcon, HbrMenuIcon, HbrPlayButtonRound, HbrSavedIcon, HbrStrikeThroughIcon, HbrVideoIcon, HbrWordDocument} from "./Mycustomsvgicons";
import { actionConsts, reducer } from "./StateManager";
import DOMPurify from "dompurify";
import { SendPost, SendShortsPost, formatMediaTime, sanitizeText} from "./GeneralClasses";
import shortswhiteicon from "../otherImg/shortswhiteimg.png";
import shortsBlackIcon from "../otherImg/shortsblackoutlineicon.png";
import { CustomAlertDialog } from "./CustomAlertDialog";
import BlogImagesSelected from "../newComponents2/BlogImagesSelected";
import SingleBlogContent from "./SingleBlogContent";
import UseLayout from "./useLayout";


const BlogPost = () => {
    const [searchBlog,setSearchBlog]=useState("");
    const [sendingPost,setSendingPost]=useState(false);
    const [posts,setPosts]=useState([]);
    const [lastDoc,setLastDoc]=useState(null);
    const [isFetching,setIsFetching]=useState(false);
    const [shorts,setShorts]=useState([]);
    const shortsRowRef = useRef();
    const [selectedVideoUri,setVideoUri]=useState(null);
    const [thumbnailUri,setThumbnailUri]=useState(null);
    const [isplaying, setIsplaying] = useState(false);
    const [state,dispatch]= useReducer(reducer,{isbold:false, isItalic: false, isHighlight: false, isStrikeThrough: false, blogText: "", selection: {start: 0, end: 0}, showCC: false, isEditorMode: false, preparedVidBlob: "", thumbBlob: "", createShorts: false, selectedShortVidUri: "",preparedShortsVidBlob: "",shortVidThumbUri: "", shortsVidThumbBlob: "", 
    videoSize: "", videoDuration: "", shortsDescText: "", shortsDescCount: 0, uploadProgress: "",progressIndicator: false, showAlert: false, alertMessage: ""});
    const [wordcount,setWordcount]=useState(0);
    const [savedBlogPosts,setSavedBlogPosts]=useState([]);
    const [showSavedBlogfeeds,setShowSavedBlogfeed]=useState(false);
    const [showsidebarleft,setShowsideLeft]=useState(false);
    // const [showRightSidebar,setShowrightsidebar]=useState(false);
    // const [showSearch,setShowSearch]=useState(false)
    const [addVideo,setAddvideo]=useState(false);
    const [showCreatePost,setCreatePost]=useState(false);
    const [selectedBlogImages,setBlogimagesSelected]=useState([]);
    const {id} = useParams();
    const [postOnFocus,setPostOnFocusData]=useState(null);
    const now = Timestamp.now();
    const utcTime = new Date(now?.toDate()).toUTCString();
    const timestamp = new Date().getTime();
    const today = new Date();
    const postID = format(today,"yyyyMMddHHmmss");
    const currentYear = format(new Date(),"yyyy");
    const {userName} = useContext(AuthContext);
    const {profile_pic} = useContext(AuthContext);
    const {user_email}= useContext(AuthContext);
    const {verifiedUid} = useContext(AuthContext);
    const {bloggerid} = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();
    const videoselectRef = useRef();
    const videoPlayerRef = useRef();
    const canvaRef = useRef();
    const shortVidSelectRef = useRef(null);
    const shortsPlayerRef = useRef(null);
    const shortsCanvaRef = useRef(null);
    const imageSelectorRef = useRef(null);
    let html = useRef("");
    const sideBarRef = useRef(null);
    const {width}=UseLayout();




    useEffect(()=>{
        const doc_ref = doc(db,"Blog Posts",id);
        getDoc(doc_ref).then((snapshot) =>{
            if(snapshot.exists()){
                setPostOnFocusData(snapshot.data());
            }
        }).catch((error)=>{
        });
    },[id]);

    const postPicOnly=()=>{
        setCreatePost(true);
        setAddvideo(false);
    };
    const postVidOnly=()=>{
        setCreatePost(true);
        setAddvideo(true);
    };

    const goToProfileUpdate=()=>{
        navigate("/account/update", {state: {from: location.pathname}});
    };

    const getMorePost = async()=>{
        setIsFetching(true);
        const collectionref = collection(db,"Blog Posts");
        const q = query(collectionref,orderBy('timestamp','desc'),startAfter(lastDoc),limit(10));
        
        const unsub = onSnapshot(q, (snapshot)=>{
            const postItems = [];
                snapshot.forEach((doc)=>{
                    postItems.push(doc.data());
                });
                postItems.length === 0 ?
                    console.log("finished fetching documents")
                :
                setPosts(prev => [...prev, ...postItems]);
                setLastDoc(snapshot.docs[snapshot.docs.length - 1]);
            
            setIsFetching(false)
        });
        return unsub;
    };
    
    useEffect(()=>{
        const collectionref = collection(db,"Blog Posts");
        const q = query(collectionref,orderBy('timestamp','desc'),limit(10));
        const unsub = onSnapshot(q, (snapshot)=>{
            const postItems = [];
            snapshot.forEach((doc)=>{
                postItems.push(doc.data());
            });
            const filteredPost = postItems.filter(postid => postid.postID !== id);
            setPosts(filteredPost);
            setLastDoc(snapshot.docs[snapshot.docs.length - 1]);
        });
        return unsub;
    },[id]);

    useEffect(()=>{
        const collectionref = collection(db,"shorts");
        const q = query(collectionref,orderBy('timestamp','desc'),limit(100));
        const unsub = onSnapshot(q, (snapshot)=>{
            const shortVideos = [];
            snapshot.forEach((doc)=>{
                shortVideos.push(doc.data());
            });
           setShorts(shortVideos);
            // setLastShorts(snapshot.docs[snapshot.docs.length - 1]);
        });
        return unsub;
    },[]);

    const showMoreShorts=(offset)=>{
        shortsRowRef.current.scrollLeft += offset;
    };
    // const images = [image1,image2,image3,image4,image5,image6];
    const uploadImage = async (image, index) => {
        return new Promise((resolve, reject) => {
          const uploadTask = uploadBytesResumable(storageRef(storage, 'post-pics2/' + index), image);
      
          uploadTask.on(
            (error) => {
              reject(error);
            }, 
            () => {
              getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                resolve(downloadURL);
              });
            }
          );
        });
    };

    const sendPost = async()=>{
        if(verifiedUid){
            if(state.blogText !== ""){
                setSendingPost(true);
                const imagelinks = [];
                for(let i = 0; i < selectedBlogImages.length; i++) {
                  if(selectedBlogImages[i]) {
                    const randImageNum= Math.floor(Math.random() * 100000000);
                    const url = await uploadImage(selectedBlogImages[i], `${userName+randImageNum+postID}`);
                    imagelinks.push(url);
                  }
                }

                if(state.preparedVidBlob && state.preparedVidBlob !== ""){
                    const uploadVidTask = uploadBytesResumable(storageRef(storage, 'blog_videos/' + postID), state.preparedVidBlob);
                      uploadVidTask.on(
                        (error) => {
                         
                        }, 
                        () => {
                          getDownloadURL(uploadVidTask.snapshot.ref)
                          .then(async(downloadURL) => {
                            if(downloadURL){
                                if(state.thumbBlob !== ""){
                                    const uploadThumbnail = uploadBytesResumable(storageRef(storage, 'blog_video_thumbs/' + postID), state.thumbBlob);
                                    uploadThumbnail.on(
                                        (error)=>{
                                          
                                        },
                                        ()=>{
                                            getDownloadURL(uploadThumbnail.snapshot.ref)
                                            .then((getVideoThumbnail)=>{
                                                if(getVideoThumbnail){
                                                    SendPost(postID,utcTime,state.blogText,imagelinks,downloadURL, getVideoThumbnail, userName, profile_pic, user_email,bloggerid, timestamp)
                                                    .then((res)=>{
                                                        if(res === true){
                                                            setSendingPost(false);
                                                            handleCloseCreatePostDiv();
                                                        }
                                                    }).catch((err)=>{
                                                        setSendingPost(false);
                                                        handleCloseCreatePostDiv();
                                                    })
                                                }
                                             
                                            });
                                        }
                                    )
                                }else{
                                        try {
                                            await SendPost(postID,utcTime,state.blogText, imagelinks, state.videoLink, state.thumbnailLink, userName, profile_pic, user_email,bloggerid, timestamp);
                                            setSendingPost(false);
                                            handleCloseCreatePostDiv();
                                            
                                        } catch (error) {
                                            setSendingPost(false);
                                            handleCloseCreatePostDiv();
                                            console.log(error);
                                        }
                                                              
                                }
                            }
                            
                          });
                        }
                      );

                }else{
                  try {
                    await SendPost(postID,utcTime,state.blogText, imagelinks, "", "", userName, profile_pic, user_email,bloggerid, timestamp);
                    setSendingPost(false);
                    handleCloseCreatePostDiv();
                  } catch (error) {
                    setSendingPost(false);
                    handleCloseCreatePostDiv();
                    console.log(error);
                  }
                }
            }
        }
       
    };

    const getSavedPosts = ()=>{
        initDB().then(()=>{
            getMySavedPosts().then(async(data)=>{
                    if(data){
                        const postItems = [];
                        for (let i = 0; i < data.length; i++) {
                            if(data && data[i].blogId){
                                const q = query(collection(db,"Blog Posts"),where('postID','==',`${data[i].blogId}`),orderBy('timestamp','desc'),limit(50));
                                const snapshot = await getDocs(q);
                                        snapshot.forEach((doc)=>{
                                            postItems.push(doc.data());
                                        });
                            }
                        }
                        setSavedBlogPosts(postItems);
                        dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false}); 
                      }

            }).catch((err)=>{
                dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
            
            });
            
        }).catch((error)=>{
            dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
        });
    };
    
    const handleShowSavedBlogs=()=>{
        setShowSavedBlogfeed(true);
        dispatch({type: actionConsts.PROGRESSINDICATOR, payload: true});
        getSavedPosts();
    };

    const handleCloseSavedBlogs=()=>{
        setShowSavedBlogfeed(false);
        setSavedBlogPosts([]);
        if(state.progressIndicator){
            dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
        }
    };

    const handleCloseCreatePostDiv=()=>{
        setCreatePost(false);
        setAddvideo(false);
        setVideoUri(null);
        setThumbnailUri(null);
        setBlogimagesSelected([]);
        dispatch({type: actionConsts.TEXT, payload: ""});
        dispatch({type: actionConsts.SELECTION, payload: {start: 0, end: 0}});
        dispatch({type: actionConsts.CARBONCOPY,showCC: false});
    };

    const handleVideoPlayback=()=>{
        if(!isplaying){
            videoPlayerRef.current.play();
        }else{
            videoPlayerRef.current.pause();
            setIsplaying(false);
        }
        setIsplaying(!isplaying);
    };

    const handleVideoChange=(e)=>{
        try {
            const file = e.target.files[0];
            if(file){
                const videoSize = file.size / (1024 * 1024);
                if(videoSize > 150){
                  dispatch({type: actionConsts.SHOWALERT, payload: true});
                  dispatch({type: actionConsts.ALERT_MESSAGE, 
                    payload: `Current video size ${videoSize.toFixed(0)}MB is bigger than 40 megabyte. Select a new video with size, 150 MB or less `});
                   
                }else{
                    setVideoUri(URL.createObjectURL(file));
                    dispatch({type: actionConsts.PREPAREDVIDBLOB, payload: file});
                }
            }
      
        } catch (error) {
            console.log(error)
        }
    };

    const handleCaptureThumbnail=useCallback(()=>{
                if(selectedVideoUri && selectedVideoUri !== ""){
                    const canvas = canvaRef.current;
                    const video = videoPlayerRef.current;
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    setThumbnailUri(canvas.toDataURL("image/jpeg"));
                    canvas.toBlob((blob)=>{
                        dispatch({type: actionConsts.THUMBBLOB, payload: blob});
                    },'image/jpeg');
                }
       
    },[selectedVideoUri]);

    useEffect(()=>{
        let timeid = setTimeout(() => {
            handleCaptureThumbnail()
        }, 2000);
        return () => clearTimeout(timeid);
    },[handleCaptureThumbnail]);


    const handleVideoSelector=()=>{
        videoselectRef.current.click();
    };

    useEffect(()=>{
        let words = state.blogText.split(' ');
         if(words.length >= 5000){
             // words.length = 4000;
             words = words.slice(0,5000);
             dispatch({type: actionConsts.TEXT, payload: words.join(' ')});
         }
         setWordcount(words.length);
     },[state.blogText]);
 
     const handleDisableBlogTextArea=(e)=>{
         if(wordcount >= 5000 && e.key !== 'Backspace' && e.key !== 'Delete'){
             e.preventDefault();
         }
     };

    const handleBlogTextChange=(e)=>{
        dispatch({type: actionConsts.TEXT, payload: e.target.value});
    };
    const handleSelectionChange=(e)=>{
        dispatch({type: actionConsts.SELECTION, payload: {start: e.target.selectionStart, end: e.target.selectionEnd}})
    };

    const applyFormat = (markSyntax)=>{
        const {start, end} = state.selection;
        if(start !== end){
            dispatch({type: actionConsts.TEXT, 
                payload: state.blogText.slice(0,start) + markSyntax + state.blogText.slice(start,end) +markSyntax + state.blogText.slice(end)});
               !state.showCC && dispatch({type: actionConsts.CARBONCOPY, payload: true});    
        }
    };

    const handleCarbonCopy=useCallback(()=>{
        html.current = state.blogText;
        html.current = html.current
        .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
        .replace(/_(.*?)_/g, '<em>$1</em>')
        .replace(/~(.*?)~/g, '<mark>$1</mark>')
        .replace(/-(.*?)-/g, '<del>$1</del>');
    
        html.current = DOMPurify.sanitize(html.current);
    },[state.blogText]);

    useEffect(()=>{
        handleCarbonCopy();
    },[handleCarbonCopy]);

    const handleShowEditorMode=()=>{
        dispatch({type: actionConsts.CARBONCOPY, payload: !state.showCC});
        dispatch({type: actionConsts.EDITORMODE, isEditorMode: false})
    };

    const handleShortVideoChange=async(e)=>{
        try {
            const file = e.target.files[0];
            if(file){
                const videoSize = file.size / (1024 * 1024);
                
                if(videoSize > 100){
                    dispatch({type: actionConsts.SHOWALERT, payload: true});
                    dispatch({type: actionConsts.ALERT_MESSAGE, 
                      payload: `Current video size ${videoSize.toFixed(0)}MB is bigger than 40 megabyte. Select a new video with size, 100MB or less `});
                }else{
                    const myVideoUri = URL.createObjectURL(file);
                    const videoElement = document.createElement('video');
                    videoElement.src = myVideoUri;

                    await new Promise((resolve)=> videoElement.addEventListener('loadedmetadata',resolve));
                    if(videoElement.duration > 180){
                        dispatch({type: actionConsts.SHOWALERT, payload: true});
                        dispatch({type: actionConsts.ALERT_MESSAGE, 
                          payload: `short videos should not be more than 3 minutes. Your selected video duration is ${formatMediaTime(videoElement.duration)}`});
                    }else{
                        dispatch({type: actionConsts.SELECTEDSHORTVID, payload: myVideoUri});
                        dispatch({type: actionConsts.PREPAREDSHORTVID, payload: file});
                        dispatch({type: actionConsts.VIDEOSIZE, payload: videoSize.toFixed(0)});
                        dispatch({type: actionConsts.VIDEO_DURATION, payload: formatMediaTime(videoElement.duration)});

                    }
                }
            }
        } catch (error) {
            console.log(error)
        }
    };

    const handleCloseShortsPlayer=()=>{
        dispatch({type: actionConsts.CREATESHORTS, payload: false});
        dispatch({type: actionConsts.SELECTEDSHORTVID, payload: ""});
        dispatch({type: actionConsts.PREPAREDSHORTVID, payload: ""});
        dispatch({type: actionConsts.SHORTVIDTHUMB, payload: ""});
        dispatch({type: actionConsts.SHORTVIDTHUMBBLOB, payload: ""});
        setIsplaying(false);
    };

    const handleShortsPlayback=()=>{
        if(isplaying){
            shortsPlayerRef.current.pause();
        }else{
            shortsPlayerRef.current.play();
        }
        setIsplaying(prev => !prev);
    };

    const handleSelectShortVid=()=>{
        shortVidSelectRef.current.click();
    };

    const handleCaptureShortsThumb=useCallback(()=>{
        if(state.selectedShortVidUri && state.selectedShortVidUri !== ""){
            const canvas = shortsCanvaRef.current;
            const video = shortsPlayerRef.current;
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            dispatch({type: actionConsts.SHORTVIDTHUMB, payload: canvas.toDataURL("image/jpeg")});
            canvas.toBlob((blob)=>{
                dispatch({type: actionConsts.SHORTVIDTHUMBBLOB, payload: blob});
            },'image/jpeg');
        }

    },[state.selectedShortVidUri]);

    useEffect(()=>{
    let timeid = setTimeout(() => {
       handleCaptureShortsThumb();
    }, 2000);
    return () => clearTimeout(timeid);
    },[handleCaptureShortsThumb]);

    useEffect(()=>{
        let words = state.shortsDescText.split(' ');
         if(words.length >= 200){
             words = words.slice(0,200);
             dispatch({type: actionConsts.SHORTS_DESC, payload: words.join(' ')});
         }
         dispatch({type: actionConsts.SHORTS_DESC_COUNT, payload: words.length});
     },[state.shortsDescText]);
 
     const handleDisableShortsTextarea=(e)=>{
         if(state.shortsDescCount >= 400 && e.key !== 'Backspace' && e.key !== 'Delete'){
             e.preventDefault();
         }
     };

     const handleUploadShorts=()=>{
        if(state.preparedShortsVidBlob !== ""){
            setSendingPost(true);
            const uploadShortVideo = uploadBytesResumable(storageRef(storage,`shorts_video/${postID}`),state.preparedShortsVidBlob);
            uploadShortVideo.on("state_changed",
                (snapshot)=>{
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes).toFixed(2) * 100;
                dispatch({type: actionConsts.UPLOAD_PROGRESS, payload: `Uploaded...${progress}%`});

                },
                (error)=>{
                    console.log(" hbr shorts fixes");
                },
                ()=>{
                    getDownloadURL(uploadShortVideo.snapshot.ref).then((downloadshortURL)=>{
                        if(downloadshortURL){
                            if(state.shortsVidThumbBlob !== ""){
                                const uploadShortVideoThumb = uploadBytesResumable(storageRef(storage,`shorts_thumb/${postID}`),state.shortsVidThumbBlob);
                                uploadShortVideoThumb.on(
                                    (error)=>{

                                    },
                                    ()=>{
                                        getDownloadURL(uploadShortVideoThumb.snapshot.ref).then((downloadThumbUrl)=>{
                                            if(downloadThumbUrl){
                                                SendShortsPost(postID,utcTime,downloadshortURL,downloadThumbUrl,"",state.shortsDescText,userName,profile_pic,user_email,timestamp,currentYear,bloggerid)
                                                .then((res)=>{
                                                    if(res === true){
                                                        setSendingPost(false);
                                                        handleCloseShortsPlayer();
                                                    }
                                                }).catch((err)=>{
                                                    setSendingPost(false);
                                                    handleCloseShortsPlayer();
                                                    console.log(err);
                                                });
                                            }
                                           
                                        });
                                    }
                                );
                            }else{
                                SendShortsPost(postID,utcTime,downloadshortURL,"","",state.shortsDescText,userName,profile_pic,user_email,timestamp,currentYear,bloggerid)
                                .then((res)=>{
                                    if(res === true){
                                        setSendingPost(false);
                                        handleCloseShortsPlayer();
                                    }
                                }).catch((err)=>{
                                    setSendingPost(false);
                                    handleCloseShortsPlayer();
                                    console.log(err);
                                });
                            }
                        }
                    });
                }
            );
        }
     }

     const handleCloseAlert=(data)=>{
        if(data === "close"){
            dispatch({type: actionConsts.SHOWALERT, payload: false});
        }
    };

    const handleImageChange=(e)=>{
        const newImages = Array.from(e.target.files).splice(0, 15);
        if (selectedBlogImages.length + newImages.length > 15) {
            dispatch({type: actionConsts.ALERT_MESSAGE, payload: "You are allowed to select a maximum of 15 images"});
            dispatch({type: actionConsts.SHOWALERT, payload: true});
        }else{
            setBlogimagesSelected(prev => [...prev, ...newImages]);
        }
    }

    const handleSelectImages=()=>{
        imageSelectorRef.current.click();
        setAddvideo(false);
    }

    const handleClearImage=(index)=>{
        if (index) {
            let newImagesArray = [...selectedBlogImages];
            newImagesArray.splice(index,1);
            setBlogimagesSelected(newImagesArray);
        }
    };

    const handleClosePage=()=>{
        if (location.state && location.state.from) {
            navigate(location.state.from);
        }else{
            navigate("/");
        }
    };

    useEffect(()=>{
        const closeSideBar=(e)=>{
          if (sideBarRef.current) {
            if (!sideBarRef.current.contains(e.target)) {
              setShowsideLeft(false);
            }
          }
        };
        document.addEventListener("mousedown", closeSideBar);
        return()=>document.removeEventListener("mousedown", closeSideBar);
     },[]);


    return ( 
        <div className="divineblogs">
            <div className="blogtopsection">

                <div className='blogmenubar'>
                    <HbrMenuIcon width={"2em"} height={"2em"} fillColour={"black"} handleClick={() => setShowsideLeft(true)}/>
                </div>

                {width > 1110 && <Hbrbackarrow width={"1.8em"} height={"1.8em"} fillColour={"black"} handleClick={() => handleClosePage()}/>}

                <div className="searchblog">
                    <input id="desktopsearch" type="search" placeholder="search for a blog" value={searchBlog} onChange={e => setSearchBlog(e.target.value)}/>
                </div>

                <div className="blogtoplogo">
                    <h4 style={{color:"teal"}}><span style={{color:"#eb268f"}}>Divine</span>Blogs</h4>
                    <img src={hbricon} alt=""/>
                </div>
            </div>
            
            {state.showAlert &&
                <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={handleCloseAlert} />
            }
        

            <div className="blogbody">
                 <div className="leftsidebar">
                    <nav className="leftsidebarnav">
                        {verifiedUid &&
                            (
                            <div className="blogsidebaritems"  onClick={()=>navigate(`/profilepage?hbruserref=${sanitizeText(user_email)}&socialhandle=${userName}`, 
                            {state: {from: location.pathname}})}>
                                {
                                profile_pic && profile_pic !== null ? <img id="blogProfile" src={profile_pic} alt="" />
                                :
                                <HbrAvatarProfile2 width="2em" height="2em" fillColour="#eb268f" />
                                }
                                {userName ? <h3>{userName}</h3> : <h3>{""}</h3>}
                            </div>
                            )
                        }
                
                        {verifiedUid ?
                            (
                                <div className="blogsidebaritems" onClick={()=>goToProfileUpdate()}>
                                <HbrEditIcon width="1.8em" height="1.8em" fillColour="#000000"/>
                                    <h4>Edit Profile</h4>
                                </div>
                            )
                            :
                            (
                                <div className="blogsidebaritems" onClick={()=>goToProfileUpdate()}>
                                    <HbrAvatarProfile width="2em" height="2em" fillColour="#eb268f" />
                                    <h4>Create Account</h4>
                                </div>
                            )
                        }
                     

                        <div className="blogsidebaritems"  onClick={handleShowSavedBlogs}>
                            <HbrSavedIcon width="1.6em" height="1.6em" fillColour="#eb268f"/>
                            <h4>Saved Posts</h4>
                        </div>

                        <div className="blogsidebaritems"  onClick={()=>setCreatePost(true)}>
                            <HbrAddIcon width="1.8em" height="1.8em" fillColour="#000000"/>
                            <h4>Create Blog</h4>
                        </div>

                        <div className="blogsidebaritems"  onClick={()=>dispatch({type: actionConsts.CREATESHORTS, payload: true})}>
                            <img src={shortsBlackIcon} alt="" style={{width:"1.6em",height:"1.6em",objectFit:"contain"}}/>
                            <h4>Create shorts</h4>
                        </div>

                    </nav>
                </div>

            <div className="feedsection">
                <div className="shortsParent">
                    
                        <button onClick={()=>showMoreShorts(-250)} id="shortsparentbackarrow"
                                style={{border:"none",borderRadius:"50%",padding:"10px",cursor:"pointer"}} className="prev_shorts">
                            <ArrowBackIos/>
                        </button>
                        
                        <div className="shortsHolder" ref={shortsRowRef}>
                
                            {shorts && shorts.map((data,index)=>(
                                <DivineShorts
                                key={index}
                                shorts_vid={data.shorts_vid}
                                shorts_desc={data.shorts_desc}
                                shorts_email={data.shorts_email}
                                shorts_name={data.shorts_name}
                                shorts_profile={data.shorts_profile}
                                shorts_text={data.shorts_text}
                                shorts_thumbnail={data.shorts_thumbnail}
                                index={index}
                                allShorts={shorts}
                                shorts_id={data.shorts_id}
                                shorts_date={data.shorts_date}
                                />
                            ))}
                        </div>

                        <button onClick={()=>showMoreShorts(250)} id="shortsparentnextarrow"
                                style={{border:"none",borderRadius:"50%",padding:"10px",cursor:"pointer"}} className="next_shorts">
                                <ArrowForwardIos/>
                        </button>
                </div>
          
                <div className="createpost">
                    <div className="addblogtext">
                        {
                            profile_pic && profile_pic !== null?  <img id="blogProfile" src={profile_pic} alt="" />
                            :
                           <HbrAvatarProfile2 width={"2em"} height={"2em"} />
                        }
                        <input type="text" readOnly placeholder="write your blog" onClick={()=>setCreatePost(true)}/>
                    </div>

                    <div className="addblogmedia">
                        <div className="addpostpicorvideo flex-row2" 
                             onClick={()=>postPicOnly()}>
                              <HbrImageIcon width="1.8em" height="1.8em" fillColour="#128C7E"/>
                                <p style={{fontWeight:"bolder"}}>Add picture</p>
                        </div>

                        <div className="openshortsdivaddbtn flex-row2" onClick={()=>dispatch({type: actionConsts.CREATESHORTS, payload: !state.createShorts})}>
                                    <img src={shortsBlackIcon} alt="" />
                                    <p style={{color:"black", fontWeight:"bold"}}>Shorts</p>
                        </div>
               
                        <div className="addpostpicorvideo flex-row2" 
                            onClick={()=>postVidOnly()}>
                                 <HbrVideoIcon width="1.8em" height="1.8em" fillColour="orangered"/>
                                <p style={{fontWeight:"bolder"}}>Attach Video</p>
                        </div>
                    </div>
                </div>

                <div className="singleblogcollection">
                                {postOnFocus && 
                                    <SingleBlogContent
                                    key={postOnFocus.timestamp}
                                    postID ={postOnFocus.postID}
                                    blog_message = {postOnFocus.blog_message}
                                    blogger_email = {postOnFocus.blogger_email}
                                    videolink = {postOnFocus.video_url}
                                    video_thumb={postOnFocus.video_thumb}
                                    images={postOnFocus.images}
                                    edifiedby = {postOnFocus.edifiedby}
                                    timestamp = {postOnFocus.timestamp}
                                    blogger_name={postOnFocus.blogger_name}
                                    />
                                }
                </div>

                {!showSavedBlogfeeds && 
                    <div className="blogcollection">

                            {posts && posts.filter((postfilter)=>{
                                if(searchBlog === ""){
                                    return true;
                                }
                                if((postfilter.blogger_name && postfilter.blogger_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchBlog.toLowerCase())) || 
                                    (postfilter.blog_message && postfilter.blog_message.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchBlog.toLowerCase()))){
                                    return true;
                                }
                                return false;
                            }).map((post)=>(
                                <BlogContent 
                                    key={post.timestamp}
                                    postID ={post.postID}
                                    blog_message = {post.blog_message}
                                    blogger_email = {post.blogger_email}
                                    blog_date = {post.blog_date}
                                    blogger_name = {post.blogger_name}
                                    blogger_profile_pic = {post.blogger_profile_pic}
                                    videolink = {post.video_url}
                                    video_thumb={post.video_thumb}
                                    images={post.images}
                                    edifiedby = {post.edifiedby}
                                    timestamp = {post.timestamp}
                                    bloggerpageid={post.bloggerpageid}
                                />
                            ))}
                            <button onClick={getMorePost} disabled={isFetching}>
                            {isFetching ? 'fetching...' :'Load more' }
                            </button>
                     </div>
                }

               
            <section className={`savedblogslayout ${showSavedBlogfeeds ? 'show':'hide'}`}>
                    <div className="saveblogslayoutcontents">

                    <div className="savedblogsconttop flex-spacebetween">
                            <h4>Saved Blogs</h4>
                            <HbrCloseIcon width="2em" height="2em" fillColour="#000000" handleClick={handleCloseSavedBlogs}/>
                        </div>

                        {state.progressIndicator && 
                            <div style={{
                                position: "absolute",
                                top:"50%",
                                left: "45%",
                                border: "5px solid white",
                                borderTop: "5px solid orangered",
                                width: "3em",
                                height: "3em",
                                borderRadius: "50%",
                                animation: "spin 2s linear infinite"
                            }}>

                            </div>
                        }

                        <div className="blogcollection">
                            {savedBlogPosts && savedBlogPosts.filter((postfilter)=>{
                                if(searchBlog === ""){
                                    return true;
                                }
                                if((postfilter.blogger_name && postfilter.blogger_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchBlog.toLowerCase())) || 
                                (postfilter.blog_message && postfilter.blog_message.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchBlog.toLowerCase()))){
                                return true;
                            }
                                return false;
                            }).map((post)=>(
                                <BlogContent 
                                key={post.timestamp}
                                postID ={post.postID}
                                blog_message = {post.blog_message}
                                blogger_email = {post.blogger_email}
                                blog_date = {post.blog_date}
                                blogger_name = {post.blogger_name}
                                blogger_profile_pic = {post.blogger_profile_pic}
                                videolink = {post.video_url}
                                video_thumb={post.video_thumb}
                                images={post.images}
                                edifiedby = {post.edifiedby}
                                timestamp = {post.timestamp}
                                bloggerpageid={post.bloggerpageid}
                                />
                            ))}
                        </div>
                    </div>
            
            </section>
                
                
            </div>

            <div className="rightsidebar">
           
                    <div className="helpnote">
                    <h2>Terms Of Use</h2>
                        <p>
                        The divine Blogs is restricted to the promotion and creation of Godly contents void of antisemitisms.
                        The following contents are not allowed in the Divine blogs: Hate comments or posts, sexual contents, promotion 
                        of spams. illegal or harmful drug contents, illicit ads or products, infringement on copyrighted contents, and 
                        other contents which may be unfit as determined by the administrators of the platform. Users who fail to 
                        adhere to the terms of use will be blocked and disallowed from posting contents. Your name and other few personal 
                        information is used solely to identify users and to take necessary actions if they default. You can request for your information to be deleted which will 
                        result in the dissolution of your account. By continuing to use the divine blog section, you agree to the 
                        terms of use and acknowledge reading the <em>Terms of Use.</em>
                        </p>

                        <h2>Help Summary</h2>
                        <p>
                            <strong>What can i post: </strong>
                          Aside sexual nudity and other illicit contents you can post Godly materials and other general contents like 
                          health tips, advisory contents, etc. In regards to health tips, make sure to provide references to your posts 
                          else your post will be deleted. These checks are strictly enforced due to the delicate nature of health 
                          issues. We strongly encourage you to attach pictures and references to any health material or content you post.
                          Do not Post any material that is detriment to the psyche and well-being of users. Failure to abide by the rules 
                          will leave your user account terminated and deleted.
                        </p>

                        <p>
                            <strong>Edit profile: </strong>
                            It is advisable to update your profile especially when active in creating divine blogs. Other users will 
                            have the chance to view your profile and also share your contents for wider discovery. You are provided 
                            with the option to add an About text of yourself, add your social media handles for others to follow as 
                            well.
                        </p>

                        <p>
                            <strong>Create Post: </strong>
                            you can create a post by clicking on the <em>write your blog</em> holder located at the top of your feed. 
                            Maximum words allowed in your blog is limited to 5000. You can also attach a maximum of six images or a 
                            video to your blog write up. Only users with an account can create a post. Users who are not registered 
                            or blocked will only be allowed to read blogs on their feed.
                        </p>

                        <p>
                            <strong>Send Comment: </strong>
                            Click on <em>Comment</em> to activate the comment section. Clicking on the blue colored <i>Comment </i> 
                            area will display the list of comments for a particular post. Blocked users or unregistered users 
                            are not allowed to comment. If you have registered and you are unable to send comments, contact the 
                            support team.
                        </p>

                        <p>
                            <strong>Edified by a blog post: </strong>
                            When edified or touched by a post, you can click on the Edified button to show your reaction to the 
                            content creator and other users. This will encourage the content creator to write more edifying blogs.
                            The <em>edified</em> button is heart shaped enclosed in an open hands placed next to the <em>Comment</em> trigger.
                            Clicking on the blue colored <i>edified</i> area will display the list of edified users for a particular post.
                        </p>

                        <p>
                            <strong>Delete Your Own Blog or comment: </strong>
                           Click on the menu icon at the top right corner of the blog post. Click on <em>Delete</em> among the list of options in 
                           the drop down menu.
                        </p>

                    </div>
                
            </div>

            {showCreatePost && 
              <div className="createPostfixeddiv">
                    {sendingPost && <div> <CircularProgress/> </div>}

                        <div className="flex-spacebetween" style={{width:"100%"}}>
                            <h2>Create Blog Post </h2>
                            <HbrCloseIcon width="2em" height="2em" handleClick={handleCloseCreatePostDiv}/>
                        </div>

                        {verifiedUid ? 
                        <div className="flex-spacebetween" style={{width:"100%",marginTop:"1em"}}>
                                <button id="postButton" onClick={sendPost}>Post</button>

                                <input type="file" multiple accept=".jpg, .jpeg, .png" ref={imageSelectorRef} onChange={handleImageChange} style={{display:"none"}}/>

                                <div className="flex-row2" style={{cursor:"pointer",caretColor:"transparent"}} onClick={handleSelectImages}>
                                        <HbrImageIcon width="1.6em" height="1.6em" fillColour="#128C7E"/>
                                        {width > 400 && <p style={{color:"black", fontWeight:"bold"}}>Image</p>}
                                </div> 

                                <div className="flex-row2" style={{cursor:"pointer",caretColor:"transparent"}} onClick={()=>setAddvideo(true)}>
                                        <HbrVideoIcon width="1.6em" height="1.6em" fillColour="orangered"/>
                                        {width > 400 && <p style={{color:"black", fontWeight:"bold"}}>Video</p>}
                                </div> 
                        </div>
                        :
                        <div className="flex-row2" style={{width:"60%", flexWrap:"wrap"}}>
                            <p style={{fontWeight:"bold"}}>Post disabled, User not found.If you do not have an account create one here.</p>
                            <Link style={{fontWeight:"bold"}} to={"/"}>Create account</Link>
                        </div> 
                        }

                        <div className="flex-spacebetween" style={{width:"100%",flexWrap:"wrap"}}>
                            <p style={{color:"black",marginTop:"1em",marginLeft:"1em",fontWeight:"bold"}}>
                                Word count: {`${state.blogText === "" ? '0':wordcount}`}/5000
                            </p>

                            <div className="formattingtoolbar">
                                <div
                                    onClick={handleShowEditorMode}
                                    onMouseEnter={()=> dispatch({type: actionConsts.EDITORMODE})}
                                    onMouseLeave={() => dispatch({type: actionConsts.EDITORMODE})}
                                    className="formatdivcontainer" 
                                    style={{position:"relative"}}>
                                        {!state.showCC &&
                                            <HbrWordDocument width={"2em"} height={"2em"} fillColour={"#000000"}/>
                                        }

                                        {state.showCC &&
                                            <HbrIconFileCopy width={"2em"} height={"2em"} fillColour={"#000000"}/>
                                        }

                                        {!state.showCC && state.isEditorMode && 
                                        <pre style={{fontWeight:"bold",backgroundColor:"#efefef",color:"black",left:"0px"}}>{`Plain text: \nclick to show \nEditor Copy`}</pre>
                                        }
                                        {state.showCC && state.isEditorMode && 
                                        <p style={{fontWeight:"bold",backgroundColor:"black",color:"white"}}>{`Editor Copy`}</p>
                                        }
                                </div>
                            
                                <div
                                    onClick={()=> applyFormat('*')} 
                                    onMouseEnter={()=>dispatch({type: actionConsts.BOLD})}
                                    onMouseLeave={()=> dispatch({type: actionConsts.BOLD})}
                                    className="formatdivcontainer" 
                                    style={{position:"relative"}}>

                                    <HbrBoldIcon width={"2em"} height={"2em"} fillColour={"#000000"}/>
                                    {state.isbold && <p style={{fontWeight:"bold"}}>{`Bold`}</p>}
                                </div>
                                
                                <div 
                                    onClick={()=> applyFormat("_")}
                                    onMouseEnter={()=>dispatch({type: actionConsts.ITALIC})}
                                    onMouseLeave={()=> dispatch({type: actionConsts.ITALIC})}
                                    className="formatdivcontainer" 
                                    style={{position:"relative"}}>

                                    <HbrItalicIcon width={"2em"} height={"2em"} fillColour={"#000000"}/>
                                    {state.isItalic && <p style={{fontStyle:"italic",color:"black",backgroundColor:"#efefef"}}>{`Italic`}</p>}
                                </div>

                                <div 
                                    onClick={()=> applyFormat("~")}
                                    onMouseEnter={()=>dispatch({type: actionConsts.HIGHLIGHT})}
                                    onMouseLeave={()=> dispatch({type: actionConsts.HIGHLIGHT})}
                                    className="formatdivcontainer" 
                                    style={{position:"relative"}}>

                                    {state.isHighlight && <p style={{fontWeight:"bolder",color:"yellow",backgroundColor:"black",padding:"2px"}}>{`Highlight`}</p>}
                                    <HbrHighlightIcon width={"2em"} height={"2em"} fillColour={"#ffd700"}/>
                                </div>

                                <div
                                    onClick={()=> applyFormat("-")} 
                                    onMouseEnter={()=>dispatch({type: actionConsts.STRIKE})}
                                    onMouseLeave={()=> dispatch({type: actionConsts.STRIKE})}
                                    className="formatdivcontainer" 
                                    style={{position:"relative"}}>

                                        {state.isStrikeThrough && <p style={{textDecoration:"line-through",color:"black", backgroundColor:"transparent"}}>{`StrikeThrough`}</p>}
                                    <HbrStrikeThroughIcon width={"2em"} height={"2em"} fillColour={"#000000"}/>
                                </div>

                            </div>

                        </div>
                        
                        <div className="textareaandcc flex-column2">
                            <textarea 
                            placeholder="Write your blog text here. This field should not be empty even when you intend to upload image or video only" 
                            value={state.blogText}
                            rows={5}
                            onChange={handleBlogTextChange} 
                            onKeyDown={handleDisableBlogTextArea}
                            onContextMenu={(e)=> e.preventDefault()}
                            onSelect={handleSelectionChange}/>

                            {state.showCC && 
                            <div className="carboncopyholder flex-column1">
                                <h3>Editor Copy:</h3>
                                <pre dangerouslySetInnerHTML={{__html:html.current}}/>
                            </div>
                            }   
                        </div>
                            
                        {addVideo && 
                            <div className="dropzone flex-column2">
                                <input type="file" accept="video/mp4" id="videoselector" onChange={handleVideoChange} ref={videoselectRef} style={{display:"none"}}/>
                                <label htmlFor="videoselector" onClick={handleVideoSelector}>
                                    <Button style={{backgroundColor:"#efefef",color:"black",borderRadius:"10px"}}>
                                        Attach Video
                                        <HbrPlayButtonRound width={"2em"} height={"2em"} fillColour={"#000000"}/>
                                    </Button>
                                </label>
                            

                                {!selectedVideoUri && 
                                <div className="videopreviewinfo flex-column2">
                                    <p style={{color:"white",fontWeight:"bold"}}>{`maximun upload size (40mb)`}</p>
                                </div>
                                }

                                {selectedVideoUri && 
                                    <div className="vidselecteddata flex-column2">

                                        <div className="vidselectedplayer" onClick={handleVideoPlayback}>
                                                    <video 
                                                    src={selectedVideoUri} 
                                                    ref={videoPlayerRef}
                                                    loop 
                                                    width="100%" 
                                                    height="250px" />
                                        </div>
                                        
                                        <div className="vidselectedthumb">
                                         
                                                <img src={thumbnailUri && thumbnailUri} alt="" style={{width: "100%",height:"100%",objectFit:"contain"}} />
                                                <div style={{position:"absolute",
                                                            top:"50%",
                                                            left:"30%",
                                                            width: "max-content",
                                                            backgroundColor:"#10101080",
                                                            display: "grid",
                                                            placeItems: "center"
                                                        
                                                            }}>
                                                    <p style={{color:"white",fontWeight:"bold"}}>Video Thumbnail</p>
                                                </div>
                                                <div style={{position:"absolute",
                                                            top:"100%",
                                                            left:"40%"
                                                            }}>
                                                    <Button onClick={handleCaptureThumbnail} style={{border:"1px solid black"}}>recapture</Button>
                                                </div>
                                        </div>
                                        
                                        <canvas ref={canvaRef} style={{display:"none"}} />
                                    
                                    </div>
                                }

                            </div>
                        }
                          <div className="flex-row2" style={{width:"100%", flexWrap:"wrap", gap:"10px"}}>
                                {selectedBlogImages && selectedBlogImages.map((data,index)=>(
                                    <BlogImagesSelected
                                    key={index}
                                    index={index}
                                    imageuri={data}
                                    clearImage={handleClearImage}
                                    />
                                ))}
                        </div>
                    
            </div>
            }


            {state.createShorts && 
                <div className="createshortsdiv">
                    <div className="createshortsdivoverlay">
                        {state.selectedShortVidUri !== "" && 
                         <video
                         onClick={handleShortsPlayback}
                         src={state.selectedShortVidUri}
                         ref={shortsPlayerRef}
                         loop
                         width="100%"
                         height="100%"/>
                        }

                        {sendingPost && 
                        <div className="uploadshortsprogressinfo flex-column2">
                             <p style={{color: "white",fontWeight:"bold"}}>{state.uploadProgress}</p>
                            <div className="uploadshortspreloader">
                                <p style={{color: "white",fontWeight:"bold"}}>Uploading...</p>
                            </div>
                        </div>
                       
                        }

                         <div className="createshortstopinfo">
                            {state.selectedShortVidUri === "" && 
                                <h4 style={{color: "white"}}>
                                {`Maximum video size allowed for short videos, 40MB. Short videos should not be more than 180 video seconds or 3 minutes.`}
                                </h4>
                            }
                           
                            <br/>
                            {state.selectedShortVidUri !== "" && 
                              <pre style={{color:"white", whiteSpace:"pre-wrap",fontWeight:"bold"}}>
                              {`Current video size: ${state.videoSize}MB \nVideo duration: ${state.videoDuration}`}
                            </pre>
                            }
                          
                        </div> 
                        
                        {verifiedUid ? 
                            <div className="createshortsdivbuttons flex-row2">
                                 <Button onClick={handleCloseShortsPlayer}>
                                     Close
                                 </Button>
     
                                 <label htmlFor="shortsvidselector" onClick={handleSelectShortVid}>
                                 <Button>{`${state.selectedShortVidUri !== "" ? 'Change': 'Select'}`}</Button>
                                 </label>
                               
                                 <Button onClick={handleUploadShorts}>Post</Button>
     
                                 <input type="file" accept="video/mp4" id="shortsvidselector" onChange={handleShortVideoChange} ref={shortVidSelectRef} style={{display:"none"}}/>
     
                            </div>
                            :
                            <div className="createshortsdivbuttons flex-row2" style={{flexWrap:"wrap", width:"60%"}}>
                                <p style={{color:"white", fontWeight:"bold"}}>
                                    Post disabled. User Not Found. If you do not have an account create one here.
                                </p>
                                <Link style={{color:"blue", textDecoration:"none", padding:"5px",backgroundColor:"white"}} to={"/"}>Create account</Link>

                                <Button style={{color:"blue", textDecoration:"none", padding:"5px",backgroundColor:"white"}} 
                                        onClick={()=>dispatch({type: actionConsts.CREATESHORTS, payload: !state.createShorts})}>
                                     Cancel
                                </Button>
                            </div>
                        }
               

                        <div className="createshortsdivvideothumb flex-row2">
                            <img src={state.shortVidThumbUri !== "" ? state.shortVidThumbUri : shortswhiteicon} 
                            alt="shorts video thumbnail" />

                            {state.shortVidThumbUri !== "" && 
                                <div className="flex-column1" style={{gap:"10px"}}>

                                    <p style={{color:"white",fontWeight:"bold"}}>Video Cover/Thumbnail</p>
                                    {width <= 320 ? 
                                        <button onClick={handleCaptureShortsThumb}>change Thumbnail</button>
                                        :
                                        <button onClick={handleCaptureShortsThumb}>recapture</button>
                                    }
                                    
                                </div>
                          
                            }
                           
                            <canvas ref={shortsCanvaRef} style={{display:"none"}} />
                        </div>

                        <div className="createshortsdivdescription flex-row2">
                            <textarea 
                            rows={6} 
                            placeholder="write about the short video"
                            value={state.shortsDescText}
                            onChange={e => dispatch({type: actionConsts.SHORTS_DESC, payload: e.target.value})}
                            onKeyDown={handleDisableShortsTextarea}
                            />
                            <p style={{color: "white", fontWeight: "bold"}}>
                                {`${state.shortsDescText !== "" ? state.shortsDescCount : '0'}/400`}
                            </p>
                        </div>
                    </div>
                </div>
            }
          

            <div className={`leftsidebarphone ${showsidebarleft ? 'show':'hide'}`} ref={sideBarRef}>
                <nav className="leftsidebarnav">
                        {verifiedUid &&
                            (
                            <div className="blogsidebaritems"  onClick={()=>navigate(`/profilepage?hbruserref=${sanitizeText(user_email)}&socialhandle=${userName}`, 
                            {state: {from: location.pathname}})}>
                                {
                                profile_pic && profile_pic !== null ? <img id="blogProfile" src={profile_pic} alt="" />
                                :
                                <HbrAvatarProfile2 width="2em" height="2em" fillColour="#eb268f" />
                                }
                                {userName ? <h3>{userName}</h3> : <h3>{""}</h3>}
                            </div>
                            )
                        }

                    <div className="blogsidebaritems" onClick={()=>goToProfileUpdate()}>
                       <HbrEditIcon width="1.8em" height="1.8em" fillColour="#000000"/>
                        <h4>Edit Profile</h4>
                    </div>

                    <div className="blogsidebaritems"  onClick={handleShowSavedBlogs}>
                        <HbrSavedIcon width="1.6em" height="1.6em" fillColour="#eb268f"/>
                        <h4>Saved Posts</h4>
                    </div>

                    <div className="blogsidebaritems"  onClick={()=>setCreatePost(true)}>
                        <HbrAddIcon width="1.8em" height="1.8em" fillColour="#000000"/>
                        <h4>Create Blog</h4>
                    </div>

                    <div className="blogsidebaritems"  onClick={()=>dispatch({type: actionConsts.CREATESHORTS, payload: true})}>
                        <img src={shortsBlackIcon} alt="" style={{width:"1.6em",height:"1.6em",objectFit:"contain"}}/>
                        <h4>Create shorts</h4>
                    </div>
            

                    <div className="blogsidebaritems"  onClick={()=>dispatch({type: actionConsts.CREATESHORTS, payload: true})}>
                            <HbrExitIcon width="1.8em" height="1.8em" fillColour="white" handleClick={()=>handleClosePage()}/>
                            <h4>Exit</h4>
                    </div>
                    
                    <div className="closephoneleftside">
                    <HbrArrowLeft width="1.8em" height="1.8em" fillColour="black" handleClick={()=>setShowsideLeft(false)}/>
                    </div>
                </nav>
            </div>            
            
            </div>
        </div>
     );
}
export default BlogPost;